import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'opisFormat',
    standalone: false
})
export class OpisFormatPipe implements PipeTransform {

  transform(value: any): any {
    return value.replaceAll(/\$/g, '').replaceAll('nl', ' ');
  }

}
